import { ConversationFieldRowSkeleton } from './conversation-field-row-skeleton';
import { DetailsFieldRowSkeleton } from './details-field-row-skeleton';
import { DetailsRevealSkeleton } from './details-reveal-skeleton';
import type { DetailsFieldListSkeletonVariant } from 'src/modules/communications/types/details-field-list-skeleton.type';

interface DetailsFieldListSkeletonProps {
  fieldCount: number;
  variant?: DetailsFieldListSkeletonVariant;
  revealCount?: number;
}

export const DetailsFieldListSkeleton: React.FC<
  DetailsFieldListSkeletonProps
> = ({ fieldCount, variant = 'conversation', revealCount = 0 }) => (
  <div>
    <div className="flex flex-col">
      {Array.from({ length: fieldCount }).map((_, index) =>
        variant === 'conversation' ? (
          <ConversationFieldRowSkeleton
            key={`${variant}-${index}`}
            index={index}
          />
        ) : (
          <DetailsFieldRowSkeleton
            key={`${variant}-${index}`}
            variant={variant}
          />
        )
      )}
    </div>

    {revealCount > 0 && <DetailsRevealSkeleton hiddenCount={revealCount} />}
  </div>
);
